import React from 'react';
import SettingsSearchField from './SettingsSearchField';
import SettingsCreateButton from './SettingsCreateButton';

export default function SettingsListToolbar({
	searchValue,
	onSearchChange,
	createLabel,
	onCreate,
	extra = null,
	showSearch = true,
	field = 'title',
	debounce,
	debounceTime,
	searchPlaceholder = 'Search',
	autoFocus
}) {
	return (
		<div className="settings-list-toolbar">
			{showSearch && onSearchChange ? (
				<SettingsSearchField
					value={searchValue}
					onChange={onSearchChange}
					field={field}
					debounce={debounce}
					debounceTime={debounceTime}
					placeholder={searchPlaceholder}
					autoFocus={autoFocus}
				/>
			) : null}
			{extra ? <div className="settings-toolbar-control">{extra}</div> : null}
			{createLabel && onCreate ? (
				<SettingsCreateButton label={createLabel} onClick={onCreate} />
			) : null}
		</div>
	);
}
